import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth, postAuthDestination } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const session_id = match ? decodeURIComponent(match[1]) : null;
        if (!session_id) { navigate("/login"); return; }
        // Preserved role from onboarding step (sessionStorage)
        const role = sessionStorage.getItem("kb_onboarding_role") || "client";
        const res = await api.post("/auth/google/session", { session_id, role });
        if (res.data.session_token) localStorage.setItem("kb_session_token", res.data.session_token);
        setUser(res.data.user);
        sessionStorage.removeItem("kb_onboarding_role");
        window.history.replaceState({}, "", "/app");
        const dest = postAuthDestination(res.data.user);
        navigate(dest);
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login?error=auth_failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-kb-bg" data-testid="auth-callback-page">
      <div className="text-center">
        <div className="kb-mono text-xs uppercase tracking-[0.2em] text-kb-ink-muted mb-3">Authenticating</div>
        <div className="font-serif text-2xl text-kb-ink">Setting up your research workspace…</div>
        <div className="mt-6 mx-auto w-24 h-1 bg-slate-200 rounded-full overflow-hidden">
          <div className="h-full w-1/2 bg-kb-primary animate-pulse" />
        </div>
      </div>
    </div>
  );
}
